<template>
  <v-row class="pl-5 pr-5" justify="center" align-content="center">
    <v-col cols="12"
      class="pt-0"
      v-for="indicator in indicators"
      v-bind:key="indicator.code"
    >
      <v-row justify="center" align="center">
        <v-col cols="3" class="p-0">
          <v-row justify="center">
            <v-col cols="12" class="caption text-center pb-0 pt-0">
              {{indicator.title}}
            </v-col>
            <v-col class="body-1 text-center pb-0 pt-0" cols="12" align-self="end">
              {{indicator.value}} {{indicator.unit}}
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="4">
          <v-row justify="start">
            <v-col class="pb-0 pt-0" cols="11">
              <img :src="getImgUrl(indicator.level)"/>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="3" class="pl-0 pr-2">
          <v-sparkline
            :key=indicator.date
            :smooth="16"
            :gradient="['#f72047', '#ffd200', '#1feaea']"
            :line-width="5"
            :value=indicator.array
            auto-draw
            stroke-linecap="round"
          ></v-sparkline>
        </v-col>
        <v-col cols="2" class="pl-0">
          <v-row justify="center">
            <v-col cols="12" class="caption text-center pb-0 pt-0">
              前日比
            </v-col>
            <v-col class="caption text-center pb-0 pt-0" cols="12" align-self="end">
              {{indicator.gap}} 
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" class="caption text-right pb-0 pt-0 pr-6">
      <p> チャート区間は {{dateRange[0]}} ~ {{dateRange[dateRange.length-1]}}</p>
      <p class="updatetime">{{getLastUpdate() | moment }}</p>
    </v-col>
  </v-row>
</template>

<script>
import RuleAlertIndicators from '../statics/data/rule-alert-indicators-v2.json'
import moment from "moment"

export default {
  name: 'alertIndicatorsC4OV2',
  filters: {
    moment(date) {
      return moment(date).format('YYYY/MM/DD HH時時点');
    }
  },
  props: {
    dateRange: { type: [Array], default: null },
    patients: { type: [Array], default: null },
    bed_rate: { type: [Array], default: null },
    severe_bed_rate: { type: [Array], default: null },
    severe_bed_rate_ken: { type: [Array], default: null },
    recuperation: { type: [Array], default: null },
    unknown_route_rate7days: { type: [Array], default: null },
    positive_rate7days: { type: [Array], default: null },
    hospitalized_rate: { type: [Array], default: null },
    lastweek_rate: { type: [Array], default: null },
    predict_tool: { type: [Array], default: null },
    lastupdate: { type: String, default: '' },
  },
  data: () => ({
    ruleOfAlert : RuleAlertIndicators,
    indicators : [],
  }),
  computed: {
  },
  created: function () {
    this.setIndicators()
  },
  methods: {
    getLevel(name, value){
      if (this.ruleOfAlert.level4[name] < value) return 5
      else if (this.ruleOfAlert.level3b[name] < value) return 4
      else if (this.ruleOfAlert.level3a[name] < value) return 3
      else if (this.ruleOfAlert.level2[name] < value) return 2
      else if (this.ruleOfAlert.level1[name] < value) return 1
      else return 0
    },
    setIndicators: function(){
      this.setIndicator(1,'新規陽性者',' 人',this.patients[this.patients.length-1], this.getLevel('patients',this.patients[this.patients.length-1]),this.patients)
      this.setIndicator(2,'病床使用',' %',this.bed_rate[this.bed_rate.length-1], this.getLevel('bed_rate',this.bed_rate[this.bed_rate.length-1]),this.bed_rate)
      this.setIndicator(3,'重症病床使用',' %',this.severe_bed_rate[this.severe_bed_rate.length-1], this.getLevel('severe_bed_rate',this.severe_bed_rate[this.severe_bed_rate.length-1]),this.severe_bed_rate)
    },
    getGap: function(data1, data2){
      return Math.round((data1 - data2)*10)/10
    },
    setIndicator: function(_code,_title,_unit,_value,_level,_array) {
      let gap = this.getGap(_array[_array.length-1],_array[_array.length-2])
      this.indicators.push({
        code: _code,
        title: _title,
        unit: _unit,
        value: _value,
        level: _level,
        gap: gap > 0 ? '+'+gap : gap,
        array: _array,
      })
    },
    getImgUrl: function(level) {
      let name = ''
      switch (level){
        case 0: name = 'indicator0_gray_v2'; break;
        case 1: name = 'indicator1_gray_v2'; break;
        case 2: name = 'indicator2_gray_v2'; break;
        case 3: name = 'indicator3a_gray_v2'; break;
        case 4: name = 'indicator3b_gray_v2'; break;
        case 5: name = 'indicator4_gray_v2'; break;
        default: break;
      }
      var images = require.context('../assets/', false, /\.svg$/)
      return images('./' + name + ".svg")
    },
    getLastUpdate: function(){
      return this.lastupdate
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.virus-bg {
  background-image: url("~@/assets/virus.svg");
  background-position: center center;
  background-repeat: no-repeat;
}

.bed-bg {
  background-image: url("~@/assets/bed.svg");
  background-position: center center;
  background-repeat: no-repeat;
}

.updatetime {
  color: #aaa;
}

.p-0 {
  padding: 0px;
}

.pt-0 {
  padding-top: 0px;
}

.pb-0 {
  padding-bottom: 0px;
}

.pl-0 {
  padding-left: 0px;
}

.pr-0 {
  padding-right: 0px;
}
</style>
